import styled from "styled-components";

const WhatsAppNumberSC = styled.div`
    width: 100%;
    font-family: Inter, system-ui, sans-serif;
    position: relative;
    margin-top: 12px;

    .wnLabel {
        font-size: 14px;
        margin-left: 8px;
        font-weight: 500;
        color: #6b7280;
    }

    .inputBox {
        margin-top: 6px;
        border: 1px solid #DDDAE6;
        border-radius: 12px;
        padding: 8px 16px 8px 0px;
        display: flex;
        align-items: center;

        input {
            border: none;
            outline: none;
            font-size: 16px;
            flex: 1;
            letter-spacing: 0.05em;
            background: none;
            padding: 8px 4px;
        }
    }

    .dial {
        font-weight: 500;
        font-size: 15px;
        letter-spacing: 0.05em;
        padding: 8px 4px 8px 16px;
        cursor: pointer;
    }

    .dropdown {
        position: absolute;
        width: 100%;
        margin-top: 8px;
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 8px 20px rgba(16,24,40,0.10);
        z-index: 10;
        overflow: hidden;
    }

    .search {
        width: 100%;
        padding: 16px;
        border: none;
        border-bottom: 1px solid #eee;
        outline: none;
        cursor: pointer;
    }

    .row {
        padding: 14px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        font-size: 15px
    }

    .selected {
        background: #ecfdf5;
        color: #15803d;
        font-weight: 400
    }

    .code {
        font-weight: 400
    }

    @media (max-width: 640px) {
        .inputBox {
            padding: 4px 2px 4px 0px;
            input {
                font-size: 14px;
            }
        }

        .wnLabel {
            font-size: 12px;
            font-weight: 400;
        }

        .dial {
            font-size: 14px;
            font-weight: 400;
        }

        .dropdown {
            border-radius: 8px;
        }

        .search {
            padding: 12px;
        }

        .row {
            padding: 12px;
            font-size: 12px;
        }
    }
`;


export default WhatsAppNumberSC;